import { vuexfireMutations, firebaseAction } from 'vuexfire'
import * as types from '../mutation-types'
import * as R from 'ramda'
import { stateManager } from '../helper'

const sm = stateManager({
  settings: null
})

export default {
  state: sm.get(),
  mutations: {
    [types.USER_INFO_RESET] (state) {
      sm.reset(state)
    },
    ...vuexfireMutations
  },
  actions: {
    setSettingsRef: firebaseAction(({ bindFirebaseRef }, ref) => {
      return new Promise((resolve, reject) => {
        bindFirebaseRef('settings', ref).then(resolve).catch(reject)
      })
    }),
    clearSettingsRef: firebaseAction(({ unbindFirebaseRef }) => {
      unbindFirebaseRef('settings')
    }),
    async initSettings ({ dispatch, state }, ref) {
      await dispatch('setSettingsRef', ref)
      const updates = createUpdates(state.settings)

      if (!R.isEmpty(updates)) {
        await ref.update(updates)
      }
    }
  },
  getters: {
    settings: (state) => state.settings,
    isUserInfoExist (state) {
      const isNotExist = R.both(
        R.has('.value'),
        R.propSatisfies(R.isNil, '.value')
      )
      if (R.isNil(state.settings)) return false

      return !isNotExist(state.settings)
    }
  }
}

function createUpdates (settings) {
  const updates = {}

  settings = R.isNil(settings) ? {} : settings
  if (R.isNil(settings.zoom)) updates.zoom = '1.0'
  if (R.isNil(settings.libraryFirstView)) updates.libraryFirstView = 'book'
  if (R.isNil(settings.memoFocus)) updates.memoFocus = 'excerpt'
  if (R.isNil(settings.memoDateAs)) updates.memoDateAs = 'relative'

  return updates
}
